// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5902ec74","952":"2ba23e03"}[chunkId] + ".chunk.js";
};